import React, { createContext, useState, useContext, useEffect } from 'react';
import * as authApi from '@/api/authApi';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoadingAuth, setIsLoadingAuth] = useState(true);

  useEffect(() => {
    // On mount, restore session from stored token
    if (authApi.isAuthenticated()) {
      authApi.me()
        .then(({ user }) => {
          setUser(user);
          setIsAuthenticated(true);
        })
        .catch(() => {
          // Token invalid or expired — clear it
          authApi.logout();
        })
        .finally(() => setIsLoadingAuth(false));
    } else {
      setIsLoadingAuth(false);
    }
  }, []);

  const login = async (email, password) => {
    const { user } = await authApi.login({ email, password });
    setUser(user);
    setIsAuthenticated(true);
    return user;
  };

  const register = async ({ username, email, password, birthdate }) => {
    const { user } = await authApi.register({ username, email, password, birthdate });
    setUser(user);
    setIsAuthenticated(true);
    return user;
  };

  const logout = async () => {
    await authApi.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{
      user,
      isAuthenticated,
      isLoadingAuth,
      login,
      register,
      logout,
      token: authApi.getToken(),
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};
